// modules/homeModule.ts

import { RouteRecordRaw } from 'vue-router';

const homeRoutes: Array<RouteRecordRaw> = [
  {
    path: '/profile',
    component: () => import('@/views/admin/ProfileView.vue'),
    name: 'profile',
    meta: { title: '个人信息', icon: 'icon'}
  },
  // 添加其他 Home 模块的路由
];

export default homeRoutes;
